<template>
  <v-dialog
      scrollable
      v-model="visible"
      max-width="900px"
      :fullscreen="fullscreen"
      :persistent="true"
  >
    <v-card>
      <v-toolbar flat dense>
        <v-toolbar-title class="subheading">新的申报</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="fullscreen=!fullscreen">
          <v-icon>fullscreen</v-icon>
        </v-btn>
      </v-toolbar>

      <v-divider style="max-height: 1px"/>
      <v-progress-linear class="my-0" :indeterminate="true" :active="loading" height="2"/>

      <v-card-text>
        <v-form v-model="formValid" ref="formRef" lazy-validation>
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12 sm12>
                <v-text-field
                    label="申报名称"
                    required
                    :rules="rules.required"
                    counter="150"
                    v-model="item.name"/>
              </v-flex>

              <v-flex xs3>
                <v-autocomplete
                    label="是否需要初审"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.ifPreReview"
                    item-text="name"
                    item-value="dbid"
                    :items="ifPreReviewItems"
                />
              </v-flex>

              <v-flex xs3>
                <v-autocomplete
                    label="是否需要匿名活页"
                    clearable
                    required
                    :rules="rules.required"
                    v-model="item.ifAnonymousLooseLeaf"
                    item-text="name"
                    item-value="dbid"
                    :items="ifAnonymousLooseLeafItems"
                />
              </v-flex>

              <!--<v-flex xs12 sm8>
                <proj-tpe-tree v-model="item.types"/>
              </v-flex>-->

              <v-flex sm3>
                <v-menu
                    ref="refReviewStartDate"
                    :close-on-content-click="false"
                    v-model="menuReviewStartDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px">
                  <v-text-field
                      slot="activator"
                      v-model="item.startDate"
                      label="申报日期(起始)"
                      :rules="rules.startDate"
                      hint="格式YYYY-MM-DD"
                      persistent-hint
                  />
                  <v-date-picker
                      v-model="reviewStartDate"
                      locale="zh-cn"
                      @change="nv => item.startDate= nv"
                  />
                </v-menu>
              </v-flex>

              <v-flex sm3>
                <v-menu
                    ref="refReviewEndDate"
                    :close-on-content-click="false"
                    v-model="menuReviewEndDate"
                    lazy
                    transition="scale-transition"
                    offset-y
                    full-width
                    max-width="290px">
                  <v-text-field
                      slot="activator"
                      v-model="item.finishDate"
                      label="申报日期(截止)"
                      :rules="rules.finishDate"
                      hint="格式YYYY-MM-DD"
                      persistent-hint
                  />
                  <v-date-picker
                      v-model="reviewEndDate"
                      locale="zh-cn"
                      @change="nv => item.finishDate= nv"
                  />
                </v-menu>
              </v-flex>

            </v-layout>
          </v-container>
        </v-form>
      </v-card-text>

      <v-card-actions>
        <v-spacer/>
        <v-btn color="blue darken-1" flat @click.native="visible = false">取消</v-btn>
        <v-btn color="primary" @click.native="onSave">保存</v-btn>
      </v-card-actions>

    </v-card>
  </v-dialog>
</template>

<script>
import mixin from '@/mixin'
import ProjTpeTree from '@/components/proj/widgets/ProjTpeTree'
const baseURI = '/api/proj/review/';
export default {
  mixins: [mixin.edit(baseURI)],
  components: {ProjTpeTree},
  name: "Edit",
  data() {
    return {
      formValid: false,

      item:{},
      freshItem: {
       "name": null,
       "types": [],
       "startDate" : null,
       "finishDate" : null,
       "reviewStatusId" : 'E02A4ZpsUV8',
       "statusId" : 'unpub',
       "ifPreReview" : null,
       "ifAnonymousLooseLeaf" : null,
      },

      reviewStartDate: '',
      menuReviewStartDate: false,

      reviewEndDate: '',
      menuReviewEndDate: false,

      ifPreReviewItems : ["是","否"],
      ifAnonymousLooseLeafItems : ["是","否"],

      curDate: null,

      /**
       * 验证规则
       */
      rules: {
        required: [
          v => !!v || '必填项。'
        ],
        startDate: [
          v => !!v || "必填项。",
          v => window.xutil.regexpDate().test(v) || '日期格式错误',
          v => (v && v > this.curDate) || "开始日期必须晚于当前日期。"
        ],
        finishDate: [
          v => !!v || "必填项。",
          v => (v && window.xutil.regexpDate().test(v)) || '日期格式错误',
          v => (v && v > this.item.startDate) || "截止日期必须晚于起始日期。",
          v => (v && v > this.curDate) || "截止日期必须晚于当前日期。"
        ]
      }
    }
  },

  created() {
    this.curDate = new Date().toISOString().slice(0,10)
    window.console.log(this.curDate)
  }
}
</script>

<style scoped>

</style>